import { render, staticRenderFns } from "./PlatformSyncLogs.vue?vue&type=template&id=316442f5&scoped=true&"
import script from "./PlatformSyncLogs.vue?vue&type=script&lang=js&"
export * from "./PlatformSyncLogs.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSyncLogs.vue?vue&type=style&index=0&id=316442f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316442f5",
  null
  
)

export default component.exports